import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const RemindersReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                reminders:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.REMINDERS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, reminders: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_REMINDERS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, reminders: action.payload};

        case ActionTypes.REMINDERS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_REMINDER:
            const nReminder = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, reminders: state.reminders.concat(nReminder)};
    
        case ActionTypes.UPDATE_REMINDER:
            const uReminder = action.payload;
            const updatedReminders = state.reminders.map(e => e.id === uReminder.id ? uReminder : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, reminders: updatedReminders};

        case ActionTypes.DELETE_REMINDER:
            const deId = action.payload;
            const filteredReminders = state.reminders.filter(e => e.id !== deId);
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, reminders: filteredReminders};

        default:
            return state;
    }
};
